import React, { useEffect, useState } from 'react';
import PredictionGraph from './Graphs/PredictionGraph';
import SimilarCases from './Graphs/SimilarCases';
import {
  Divider,
  LoadingSpinner,
} from '@data-products-and-ai/react-components';
import useToken from '@/utils/useToken';
import { BidContext } from '@/pages/Home/HomePage';
import WinningGraph from './Graphs/WinningGraph';

const GraphBid: React.FC = () => {
  const selectionBid = React.useContext(BidContext);
  const [bidResult, setBidResult] = useState('');
  const [probabilityResult, setProbabilityResult] = useState('');
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);
  const getToken = useToken();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const token = await getToken();
      fetch(`${import.meta.env.VITE_APP_API_URL}/get_prediction_route`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.accessToken}`,
        },
        body: JSON.stringify(selectionBid),
      })
        .then((response) => response.json())
        .then((data) => {
          setBidResult(data.Bid);
          setProbabilityResult(Math.round(data.Probability).toFixed(2) + '%');

          setResult(
            data.Probability > 60
              ? 'high'
              : (data.Probability < 60 && data.Probability > 40)
              ? 'mid'
              : 'low',
          );
        })
        .catch((error) => {
          console.log('Error fetching data from the API', error);
        })
        .finally(() => {
          setLoading(false);
        });
    };
    if (!Object.keys(selectionBid).length) return;
    fetchData();
  }, [selectionBid]);

  return (
    <div className="graphBid">
      {loading ? (
        <LoadingSpinner
          color="#8a00e5"
          backgroundColor="#ADA9C2"
          text="Loading..."
        />
      ) : bidResult === '' ? (
        <div className="graphBid-noData">
          <h3>No data to display</h3>
          <p>Select data from the inputs</p>
        </div>
      ) : (
        <>
          <div
            className={`graphBid-resultHeader graphBid-resultHeader_${result}`}
          >
            <h3>Possible result of the Bid is {bidResult}</h3>
            <h3>Probability of win is {probabilityResult}</h3>
          </div>
          {
            //<WinningGraph/>
            //<Divider />
          }
          <WinningGraph />
          <Divider />
          <SimilarCases />
          <Divider />
          <PredictionGraph />
        </>
      )}
    </div>
  );
};

export default GraphBid;
